import {RequestFactory} from "@/requests/RequestFactory";
const formularioRequest = RequestFactory.get("formulario");

export default {
  namespaced: true,
  
  state: {
    isFetching: false,
    _items: {},
    items: {
      LISTA_PRESENCA: {},
      RELATORIA_REUNIAO_ENCONTRO: {},
      PLANO_OFICINA_INTERCAMBIO_CARAVANA: {},
      RELATORIA_OFICINA_INTERCAMBIO_CARAVANA: {},
      REGISTRO_FOTOGRAFICO_MODELADO: {},
      INFORME_REUNIAO: {},
    },
  },  

  mutations: {
    FETCHING_OFF(state) {
      state.isFetching = false;
    },
    FETCHING_ON(state) {
      state.isFetching = true;
    }    
  },

  actions: {
    requestOn({commit}) { commit('FETCHING_ON'); },
    requestOff({commit}) { commit('FETCHING_OFF'); },

    fetchFormularios({commit}, payload) {
      const resource = 'formulario'
      return formularioRequest.findFormularios(payload).then(response => {
        response.data.forEach(item => commit('setItemForm', {item, resource}, {root: true}))
      });
    },

    upload({commit, dispatch}, payload) {
      return formularioRequest.postArquivos(payload).then(response => {
        const payload = {resource: 'formulario', item: response.data}
        commit('setItemForm', payload, {root: true})

        const notification = {
          type: 'success',
          message: 'Arquivos adicionados com sucesso'
        }
        dispatch('notification/add', notification, { root: true })        

        return response.data
      })
    },

    deleteArquivo({commit, dispatch}, payload) {
      dispatch('requestOn');
      return formularioRequest.deleteArquivo(payload).then(response => {
        dispatch('requestOff');
        const payload = {resource: 'formulario', item: response.data}
        commit('setItemForm', payload, {root: true})

        const notification = {
          type: 'success',
          message: 'Arquivos removido com sucesso'
        }
        dispatch('notification/add', notification, { root: true })        

        return response.data
      })
    },

    downloadArquivo({dispatch}, payload) {
      dispatch('requestOn');
      return formularioRequest.downloadArquivo(payload).then(() => {
        dispatch('requestOff');
      })
    },

    verArquivo({dispatch}, payload) {
      dispatch('requestOn');
      console.log('viewArquivo2')
      formularioRequest.viewArquivo(payload)
      dispatch('requestOff');
    },

    // Lista de Presença
    criarListaPresenca({commit, dispatch}, payload) {
      dispatch('requestOn');
      return formularioRequest.postListaPresenca(payload).then(response => {
        dispatch('requestOff');
        const payload = {resource: 'formulario', item: response.data}
        commit('setItemForm', payload, {root: true})

        const notification = {
          type: 'success',
          message: 'Lista de Presença salva com sucesso'
        }
        dispatch('notification/add', notification, { root: true })        

        return response.data
      })
    },

    editarListaPresenca({commit, dispatch}, payload) {
      dispatch('requestOn');
      return formularioRequest.putListaPresenca(payload).then(response => {
        dispatch('requestOff');
        const payload = {resource: 'formulario', item: response.data}
        commit('setItemForm', payload, {root: true})

        const notification = {
          type: 'success',
          message: 'Lista de Presença editada com sucesso'
        }
        dispatch('notification/add', notification, { root: true })        

        return response.data
      })
    },

    deleteListaPresenca({commit, dispatch}, payload) {
      dispatch('requestOn');
      return formularioRequest.deleteListaPresenca(payload).then( () => {
        dispatch('requestOff');
        const payload = {resource: 'formulario', item: payload.formulario}
        commit('deleteItemForm', payload, {root: true})
        const notification = {
          type: 'success',
          message: 'Lista de Presença removida com sucesso'
        }
        return dispatch('notification/add', notification, {root: true})
      })
    },

    // Relatoria de Reunião Encontro
    criarFormulario({commit, dispatch}, payload) {
      dispatch('requestOn');
      return formularioRequest.postFormulario(payload).then(response => {
        dispatch('requestOff');        
        const payloadCommit = {resource: 'formulario', item: response.data}
        commit('setItemForm', payloadCommit, {root: true})

        const notification = {
          type: 'success',
          message: this.payload.mensagemSucesso
        }
        dispatch('notification/add', notification, { root: true })        

        return response.data
      })
    },

    editarFormulario({commit, dispatch}, payload) {
      dispatch('requestOn');
      return formularioRequest.putFormulario(payload).then(response => {
        dispatch('requestOff');
        const payloadCommit = {resource: 'formulario', item: response.data}
        commit('setItemForm', payloadCommit, {root: true})

        const notification = {
          type: 'success',
          message: this.payload.mensagemSucesso
        }
        dispatch('notification/add', notification, { root: true })        

        return response.data
      })
    },

    deleteFormulario({commit, dispatch}, payload) {
      dispatch('requestOn');
      return formularioRequest.deleteFormulario(payload).then( () => {
        dispatch('requestOff');
        const payloadCommit = {resource: 'formulario', item: payload.formulario}
        commit('deleteItemForm', payloadCommit, {root: true})
        const notification = {
          type: 'success',
          message: 'Exclusão realizada com sucesso' //this.payload.mensagemSucesso
        }
        return dispatch('notification/add', notification, {root: true})
      })
    },
    
  },

  getters: {
    byLancamentoId: (state) => lancamentoId => {
      if(state.items){
        return Object.values(state.items)
        .filter(formulario => formulario.lancamentoFonte.id === lancamentoId)
      }
      return []
    },
    byLancamentoIdAndTipo: (state) => (lancamentoId, tipoFormulario) => {
      if(state.items){
        return Object.values(state.items[tipoFormulario])
        .find(formulario => formulario.lancamentoFonte.id === lancamentoId && formulario.tipoFormulario === tipoFormulario)
      }
      return {}
    },
  },
}